<template>
<div class='bodyer about'>
    <div class='yi-title-nav'>
        <div class='container'>
            <div class='row'>
                <div class='col-md-2 title hover' @click='scrollTo(".about")'>
                    <i class='iconfont icon-gongsijianjie'></i>关于应答
                </div>
                <div class='col-md-2 title hover' @click='scrollTo(".team")'>
                    <i class='iconfont icon-tuandui1'></i>应答团队
                </div>
                <div class='col-md-2 title hover' @click='scrollTo(".culture")'>
                    <i class='iconfont icon-wenhua'></i>公司文化
                </div>
                <div class='col-md-2 title hover' @click='scrollTo(".develop")'>
                    <i class='iconfont icon-aim'></i>发展历程
                </div>
            </div>
        </div>
    </div>
    <div class='banner about'>
        <img src='/static/image/about/banner.png'>
    </div>
    <div class='m-word m-about'>
        <div class='container'>
            <div class='row'>
                <div class='col-md-5'>
                    <div class='b-pic'>
                        <img src='/static/image/about/w.png'>
                    </div>
                </div>
                <div class='col-md-7'>
                    <div class='b-word' style="padding-top: 30px;">
                        <div class='title'>重庆应答网络科技有限公司</div>
                        <div class='title-sub'>UNNDA Network Technology co.LTD</div>
                        <br>

                        <p>重庆应答网络科技有限公司是一家专注于互联网游戏开发及运营的年轻企业，创立于2017年。</p>
                        <p>重拾游戏的回忆与情怀，是我们的初心与坚持。</p>
                        <p>不止于此，我们还希望“用游戏定义未来”。</p>
                        <p>Jane McGonigal在《游戏改变世界》中曾说，我们可以借助游戏的力量，让生活变得像游戏一样精彩。</p>
                        <p>希望您的未来，有应答游戏的陪伴，也就拥有了无尽的精彩与欢乐。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class='banner team'>
        <img src='/static/image/about/banner02.png'>
    </div>
    <div class='m-word m-team'>
        <div class='container'>
            <div class='row'>
                <div class='col-md-7'>
                    <div class='b-word' style='padding-top: 70px;'>
                        <p>我们拥有高效、专业的国际化运维团队，主要团队成员来自中国游戏顶尖团队体系——“金山系”。</p>
                        <p>团队在创业之初以“找寻记忆中的游戏人生”为目标，推出经典回忆类PC端游戏</p>
                        <p>——M2神甲奇兵online</p>
                        <p>成功重现80后玩家的少年时代。</p>
                    </div>
                </div>
                <div class='col-md-5'>
                    <div class='b-pic'>
                        <img src='/static/image/about/w02.png'>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class='banner culture'>
        <img src='/static/image/about/banner03.png'>
    </div>
    <div class='m-word m-culture'>
        <div class='container'>
            <div class='row'>
                <div class='col-md-5'>
                    <div class='b-pic'>
                        <img src='/static/image/about/w03.png'>
                    </div>
                </div>
                <div class='col-md-7'>
                    <div class='b-word' style='padding-top: 90px; padding-left: 60px;'>
                        <p>工匠精神——在浮躁的世界坚持游戏人的初心</p>
                        <p>诚信精神——诚信正直、值得信赖的商业伙伴</p>
                        <p>创新精神——积极进取、开放思想、拥抱变化</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class='banner develop'>
        <img src='/static/image/about/banner04.png'>
    </div>
    <div class='m-dev'>
        <div class='container'>
            <img src='/static/image/about/develop.png'>
        </div>
    </div>
</div>
</template>

<script type="text/javascript">
import ScrollReveal from 'scrollreveal'
export default {
    data : function(){
        return {
        }
    },
    methods : {
        //滚动
        scrollTo : function(target){
            $.smoothScroll({scrollTarget: target})
        }
    },
    mounted : function(){
        var show = ScrollReveal({
            'origin' : 'bottom',
            'distance' : '300px',
            'duration' : 400,
            'delay' : 500
        });

        show.reveal('.m-about .b-pic', {
            'origin' : 'left'
        }).reveal('.m-about .b-word', {
            'origin' : 'right'
        }).reveal('.m-team .b-pic', {
            'origin' : 'right'
        }).reveal('.m-team .b-word', {
            'origin' : 'left'
        }).reveal('.m-culture .b-pic', {
            'origin' : 'left'
        }).reveal('.m-culture .b-word', {
            'origin' : 'right'
        }).reveal('.m-dev', {
            'origin' : 'bottom'
        })
    },
    created : function(){
        window.scrollTo(0, 0)
    }
}
</script>


// WEBPACK FOOTER //
// src/components/about/Index.vue